<div class="container-fluid-modal">
    <div class="deleteWrapper">
        <div class="ModalHeader">
            <h4 mat-dialog-title> Delete </h4>
            <div class="buttonWrapper">
                <button class="btn btn-danger btn-sm" (click)="deletePO(data.getPOId)"><i class="fa fa-trash" aria-hidden="true"></i>  <span class="save_btn_txt"> DELETE </span></button>
                <button class="btn btn-warning btn-sm" (click)="close()"> <i class="fa fa-pencil-square-o" aria-hidden="true"></i>CANCEL</button>
            </div>
        </div>
        <div class="deleteBody">
            <div class="card">
                <div class="card-body">
                    <strong>  Are you sure, you want to delete this purchase order ? </strong>
                </div>
            </div>
        </div>
    </div>
</div>